export const CCSF_CARD_NUMBER_CONTAINER = 'card-number-container';
export const CCSF_CVV_CONTAINER = 'cvv-info';

export const CCSF_FIELDS = {
  cardNumber: CCSF_CARD_NUMBER_CONTAINER,
  cvv: CCSF_CVV_CONTAINER,
};
